import React, { useState, useRef, useEffect } from 'react';
import { DS } from './ds';
import { AlinovaConstellation } from './Visuals';
interface VideoBlockProps {
  src?: string;
  poster?: string;
  title?: string;
  description?: string;
  badge?: string;
  bgVideo?: string;
  zoom?: number;
  translateY?: string;
  translateX?: string;
}
export const VideoBlock = ({
  src,
  poster,
  title,
  description,
  badge,
  bgVideo,
  zoom,
  translateY,
  translateX
}: VideoBlockProps) => {
  const [playing, setPlaying] = useState(false);
  const [hovered, setHovered] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);
  const bgVideoRef = useRef<HTMLVideoElement>(null);
  useEffect(() => {
    const mq = window.matchMedia('(max-width: 768px)');
    const update = () => setIsMobile(mq.matches);
    update();
    mq.addEventListener('change', update);
    return () => mq.removeEventListener('change', update);
  }, []);

  // Forzar muted directo en el DOM — fix real para Safari/Chrome con .mov
  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.muted = true;
      videoRef.current.volume = 0;
    }
  }, []);
  useEffect(() => {
    if (bgVideoRef.current) {
      bgVideoRef.current.muted = true;
      bgVideoRef.current.volume = 0;
    }
  }, []);
  const toggle = () => {
    if (!src || !videoRef.current) return;
    if (playing) {
      videoRef.current.pause();
      setPlaying(false);
    } else {
      videoRef.current.muted = true;
      videoRef.current.volume = 0;
      videoRef.current.play();
      setPlaying(true);
    }
  };
  const card = <div style={{
    borderRadius: '20px',
    overflow: 'hidden',
    position: 'relative',
    background: `linear-gradient(135deg, ${DS.color.ink} 0%, #0a2e3a 100%)`,
    boxShadow: hovered ? '0 20px 60px rgba(11,31,36,0.35), 0 0 30px rgba(75,199,210,0.12)' : '0 12px 40px rgba(11,31,36,0.25)',
    cursor: src ? 'pointer' : 'default',
    aspectRatio: '16/9',
    transition: `box-shadow 0.3s ${DS.ease.smooth}`
  }} onClick={toggle} onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)} data-id="element-834" data-mp="1zyiisvjinw34">
      {/* Fondo constellation */}
      {!playing && <div style={{
      position: 'absolute',
      inset: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      opacity: hovered ? 0.18 : 0.11,
      transition: `opacity 0.3s ${DS.ease.smooth}`
    }} data-id="element-835" data-mp="2hh8xh53d46nm">
          <AlinovaConstellation width={260} height={260} opacity={1} data-id="element-836" data-mp="22jqdeg1mqhmi" />
        </div>}

      {/* Líneas decorativas */}
      {!playing && <div style={{
      position: 'absolute',
      inset: 0,
      backgroundImage: 'linear-gradient(rgba(75,199,210,0.04) 1px, transparent 1px), linear-gradient(90deg, rgba(75,199,210,0.04) 1px, transparent 1px)',
      backgroundSize: '32px 32px',
      pointerEvents: 'none'
    }} data-id="element-837" data-mp="1yjzd9lq7qp5b" />}

      {/* Video principal */}
      {src && <video ref={videoRef} src={src} poster={poster || ''} muted loop playsInline style={{
      width: '100%',
      height: '100%',
      display: 'block',
      objectFit: 'cover'
    }} data-id="element-838" data-mp="1jln0zuc4bt8g" />}

      {/* Video de fondo */}
      {!playing && <video ref={bgVideoRef} src={bgVideo || 'https://cdn.magicpatterns.com/uploads/18Ywnt4RdLvRwbxeeYvBnt/Video%20En%20laminador.mp4'} autoPlay loop muted playsInline style={{
      position: 'absolute',
      inset: 0,
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      opacity: 0.8,
      transform: `${zoom ? `scale(${zoom})` : ''} ${translateX ? `translateX(${translateX})` : ''} ${translateY ? `translateY(${translateY})` : ''}`.trim() || 'none'
    }} data-id="element-839" data-mp="10polqe45hpiu" />}

      {/* Footer título — solo overlay en desktop */}
      {!isMobile && <div style={{
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      padding: '20px 22px 18px',
      background: 'linear-gradient(to top, rgba(11,31,36,0.92) 0%, transparent 100%)'
    }} data-id="element-840" data-mp="2omwe1bjglrvd">
          {title && <div style={{
        fontFamily: DS.font.heading,
        fontWeight: 700,
        fontSize: '0.95rem',
        color: '#fff',
        marginBottom: '3px'
      }} data-id="element-841" data-mp="3cb789vungtao">
              {title}
            </div>}
          {description && <div style={{
        fontFamily: DS.font.body,
        fontSize: '12px',
        color: 'rgba(255,255,255,0.55)'
      }} data-id="element-842" data-mp="3gfnb1o8yvklo">
              {description}
            </div>}
        </div>}
    </div>;
  if (!isMobile) return card;

  // En móvil el texto va debajo del video para no taparlo
  return <div data-id="element-843" data-mp="3uyy8yk2dpslo">
      {card}
      {(title || description) && <div style={{
      padding: '12px 4px 0'
    }} data-id="element-844" data-mp="3h8mieplg01wn">
          {title && <div style={{
        fontFamily: DS.font.heading,
        fontWeight: 700,
        fontSize: '0.95rem',
        color: DS.color.ink,
        marginBottom: '3px',
        lineHeight: 1.25
      }} data-id="element-845" data-mp="3lzunj9fqp140">
              {title}
            </div>}
          {description && <div style={{
        fontFamily: DS.font.body,
        fontSize: '12.5px',
        color: DS.color.muted,
        lineHeight: 1.5
      }} data-id="element-846" data-mp="2yb1xtuppnphu">
              {description}
            </div>}
        </div>}
    </div>;
};